var firebaseConfig = {
  apiKey: "AIzaSyDjBemQke3-IdTS5JAiKwOqvFlDX_4Wf8E",
  authDomain: "learning-firebase-af098.firebaseapp.com",
  projectId: "learning-firebase-af098",
  storageBucket: "learning-firebase-af098.appspot.com",
  messagingSenderId: "987534806476",
  appId: "1:987534806476:web:fa2b0c803e14c5860ea169",
};
export default firebaseConfig;
